/*
 * @Author: gujianghua
 * @Date:   2018-07-21 18:00:58
 * @Last Modified by:   gujianghua
 * @Last Modified time: 2018-08-12 15:00:54
 */
import { service } from '@/utils/request'

export default {
  //分页获取银行列表
  getBankList: (params) => {
    return service({
      url: '/cloud/uac/doctor/banInfo/list',
      method: 'get',
      params: params
    })
  },
  //增加银行
  addNewBank: (data) => {
    return service({
      url: '/cloud/uac/doctor/banInfo/add',
      method: 'post',
      data: data
    })
  },
  //修改银行
  editBank: (data) => {
    return service({
      url: '/cloud/uac/doctor/banInfo/update',
      method: 'post',
      data: data
    })
  },
  //银行启用/禁用状态改变
  changState: (path) => {
    return service({
      url: '/cloud/uac/doctor/banInfo/updateState' + path,
      method: 'post',
    })
  }
}



// WEBPACK FOOTER //
// ./src/api/systemManage/bankManage.js